import React, { Component } from "react"
import PropTypes from "prop-types"
import NetPerformerScale from "./NetPerformerScale"
import PeopleSection from "./PeopleSection"
import { CHARTS } from "../../../constants"
import styled from "styled-components"
import { translate } from "react-i18next"
import  ExportMenu from "../../themed-html-components/ExportMenu"

const detractorColor = CHARTS.trafficLightColours.red
const passiveColor = CHARTS.trafficLightColours.amber
const promoterColor = CHARTS.trafficLightColours.green

const TextDiv = styled.div`
  text-align: center;
  font-weight: bold;
  white-space: -moz-pre-wrap !important; /* Mozilla, since 1999 */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  white-space: pre-wrap; /* css-3 */
  word-wrap: break-word; /* Internet Explorer 5.5+ */
  white-space: -webkit-pre-wrap; /* Newer versions of Chrome/Safari*/
  word-break: break-all;
  white-space: normal;
`

class PeopleNPS extends Component {
  state = {
    exportDisplay: "none"
  }
  toggleExportOn = () => {
    this.setState({ exportDisplay: "initial" })
  }
  toggleExportOff = () => {
    this.setState({ exportDisplay: "none" })
  }
  render() {
    const { data, widgetIdentifier, titleKey, t } = this.props

    const detractorPeople = 6
    const passivePeople = 2
    const promoterPeople = 2
  
  const detractorScores = []
  const detractorMaxCount = 6
  const passiveScores = []
  const passiveMaxCount = 8
  const promoterScores = []

  for (let i = 0; i < data.scores.length; i++) {
    if (i < detractorMaxCount) {
      detractorScores.push(data.scores[i])
    } else if (i >= detractorMaxCount && i < passiveMaxCount) {
      passiveScores.push(data.scores[i])
    } else {
      promoterScores.push(data.scores[i])
    }
  }

    return (
      <div style={{ width: "100%" }} onMouseEnter={this.toggleExportOn} onMouseLeave={this.toggleExportOff}>
        {/* <ExportMenu titleKey={titleKey}
                display={this.state.exportDisplay} 
                left="700px" 
                top="30px"
                widgetIdentifier={widgetIdentifier}
                resetDisplayProp={this.toggleExportOff}
                t={this.props.t}/> */}
        <table className="hidden-xs-down" style={{ width: "100%" }}>
          <tbody>
            <tr>
              <td style={{ width: "60%" }}>
                <TextDiv style={{ color: detractorColor }}>
                  {t("Widgets.EmployeeNetPromoterScore.Groups.Detractors")}
                </TextDiv>
              </td>
              <td style={{ width: "20%" }}>
                <TextDiv style={{ color: passiveColor }}>
                  {t("Widgets.EmployeeNetPromoterScore.Groups.Passive")}
                </TextDiv>
              </td>
              <td style={{ width: "20%" }}>
                <TextDiv style={{ color: promoterColor }}>
                  {t("Widgets.EmployeeNetPromoterScore.Groups.Promoters")}
                </TextDiv>
              </td>
            </tr>
            <tr>
              <td style={{ width: "60%" }}>
                <PeopleSection
                identifier="Detractors"
                  hexColor={detractorColor}
                  percentage={data.detractorsPercentage}
                  totalPeople={data.detractors}
                  peopleNeeded={detractorPeople}
                scores={detractorScores}
                />
              </td>
              <td style={{ width: "20%" }}>
                <PeopleSection
                identifier="Passive"
                  hexColor={passiveColor}
                  percentage={data.passivePercentage}
                  totalPeople={data.passive}
                  peopleNeeded={passivePeople}
                scores={passiveScores}
                />
              </td>
              <td style={{ width: "20%" }}>
                <PeopleSection
                identifier="Promoters"
                  hexColor={promoterColor}
                  percentage={data.promotersPercentage}
                  totalPeople={data.promoters}
                  peopleNeeded={promoterPeople}
                scores={promoterScores}
                />
              </td>
            </tr>
          </tbody>
        </table>
        {/* Mobile View */}
        <table className="hidden-sm-up" style={{ width: "100%" }}>
          <tbody>
            <tr>
              <td style={{ width: "33.33%" }}>
                <TextDiv style={{ color: detractorColor }}>
                  {t("Widgets.EmployeeNetPromoterScore.Groups.Detractors")}
                </TextDiv>
              </td>
              <td style={{ width: "33.33%" }}>
                <TextDiv style={{ color: passiveColor }}>
                  {t("Widgets.EmployeeNetPromoterScore.Groups.Passive")}
                </TextDiv>
              </td>
              <td style={{ width: "33.33%" }}>
                <TextDiv style={{ color: promoterColor }}>
                  {t("Widgets.EmployeeNetPromoterScore.Groups.Promoters")}
                </TextDiv>
              </td>
            </tr>
            <tr>
              <td style={{ width: "33.33%" }}>
                <TextDiv style={{ color: detractorColor }}>
                  {Math.round(data.detractorsPercentage)} %
                  <br /> {data.detractors} {t("People")}
                </TextDiv>
              </td>
              <td style={{ width: "33.33%" }}>
                <TextDiv style={{ color: passiveColor }}>
                  {Math.round(data.passivePercentage)} %
                  <br /> {data.passive} {t("People")}
                </TextDiv>
              </td>
              <td style={{ width: "33.33%" }}>
                <TextDiv style={{ color: promoterColor }}>
                  {Math.round(data.promotersPercentage)} %
                  <br /> {data.promoters} {t("People")}
                </TextDiv>
              </td>
            </tr>
          </tbody>
        </table>
        <NetPerformerScale
          data={data.scores}
          style={{ padding: 20 }}
          detractorColor={detractorColor}
          passiveColor={passiveColor}
          promoterColor={promoterColor}
        />
      </div>
    )
  }  
}

PeopleNPS.propTypes = {
  data: PropTypes.object,
  widgetIdentifier: PropTypes.string.isRequired,
  titleKey: PropTypes.string
}

export default translate()(PeopleNPS)



// WEBPACK FOOTER //
// ./src/components/widgets/CustomNPS/PeopleNPS.jsx